import { TimeCountDownFormat } from '@/constants/enum';
import { EFlags } from '@/constants/flags';
import {
  COUNTRY,
  END_DATE_MARKER,
  FLAG,
  PREP_END_DATE_MARKER,
  PREP_START_DATE_MARKER,
  START_DATE_MARKER,
  TIME_COUNTDOWN_MARKER,
  ZIPCODE,
} from '@/constants/string';
import { stringify } from '@/helpers/string';
import { calculateEstimatedDays, getProcessedDate } from '@/helpers/time';
import { IDataSettingState, dataSettingsSelector } from '@/redux/slice/settings.slice';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const formatCountdown = (type: TimeCountDownFormat, dataSettings: IDataSettingState) => {
  const { days, hours, minutes, seconds } = dataSettings;
  switch (type) {
    case TimeCountDownFormat.DayHourMinute:
      return `02 ${days} 10 ${hours} 30 ${minutes}`;
    case TimeCountDownFormat.DayHour:
      return `02 ${days} 10 ${hours}`;
    case TimeCountDownFormat.HourMinuteSecond:
      return `10 ${hours} 30 ${minutes} 59 ${seconds}`;
    case TimeCountDownFormat.HourMinute:
      return `10 ${hours} 30 ${minutes}`;
    case TimeCountDownFormat.Full:
    default:
      return `02 ${days} 10 ${hours} 30 ${minutes} 59 ${seconds}`;
  }
};

const renderFlag = (flag: string) => {
  const flagKey = flag.toLowerCase() as keyof typeof EFlags;
  return `<span class="flag-icon" style="background-image: url(${EFlags[flagKey]})"></span>`;
};

const useGenerateEstString = () => {
  const dataSettings = useSelector(dataSettingsSelector);

  return useCallback(
    (
      estText: string,
      orderToShipDays = 0,
      prepDays = 0,
      shipToReceiveDays = 0,
      estDays = 3,
      isInCart = false,
      country = '',
      flag = '',
      preOrderDate = '',
      isUsePreOrderDate = false,
      zipcode = '',
    ) => {
      const { startShippedDay, endShippedDay, startDeliveryDay, endDeliveryDay } = calculateEstimatedDays(
        orderToShipDays,
        prepDays,
        shipToReceiveDays,
        estDays,
        isUsePreOrderDate && preOrderDate ? new Date(preOrderDate) : undefined,
      );

      let result = estText
        .replaceAll(COUNTRY, isInCart ? COUNTRY : country)
        .replaceAll(FLAG, isInCart ? FLAG : flag ? renderFlag(flag) : '')
        .replaceAll(ZIPCODE, isInCart ? ZIPCODE : zipcode)
        .replaceAll(PREP_START_DATE_MARKER, getProcessedDate(startShippedDay) || '')
        .replaceAll(PREP_END_DATE_MARKER, getProcessedDate(endShippedDay) || '')
        .replaceAll(START_DATE_MARKER, getProcessedDate(startDeliveryDay) || '')
        .replaceAll(END_DATE_MARKER, getProcessedDate(endDeliveryDay) || '');

      if (!isInCart) {
        result = result.replaceAll(
          TIME_COUNTDOWN_MARKER,
          `<span className="otCountDown">${formatCountdown(dataSettings.type_time_countdown, dataSettings)}</span>`,
        );
      }

      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [stringify(dataSettings)],
  );
};
export default useGenerateEstString;
